const ARLA_RATING_STYLES = {
  green: { backgroundColor: '#D9F7BE', color: 'rgba(0, 0, 0, 0.85)' },
  yellow: { backgroundColor: '#FFFFB8', color: 'rgba(0, 0, 0, 0.85)' },
  orange: { backgroundColor: '#FFE7BA', color: 'rgba(0, 0, 0, 0.85)' },
  red: { backgroundColor: '#FFCCC7', color: 'rgba(0, 0, 0, 0.85)' },
  gray: { backgroundColor: '#F0F0F0', color: 'rgba(0, 0, 0, 0.85)' },
};

const DEFAULT_STYLE = { backgroundColor: '#F0F0F0', color: 'rgba(0, 0, 0, 0.85)' };

export const getArlaRatingStyle = (displayColor) =>
  ARLA_RATING_STYLES[displayColor] || DEFAULT_STYLE;
